export default {
	data() {
		return {
			apk: process.env.VUE_APP_GBLINK || process.env.VUE_APP_DEFAULT_APK,
			from: 'gb',
			filename: 'gb',
		};
	},
	mounted() {
		this.from = this.$global.GetQueryString('from') || this.from;
		this.filename = this.$global.GetQueryString('filename') || this.filename;
		if (this.$global.GetQueryString('from')) {
			this.getAPK();
		} else {
			this.getOfficalApk();
		}
	},
	methods: {
		fallbackApk() {
			return process.env.VUE_APP_GBLINK || process.env.VUE_APP_DEFAULT_APK;
		},
		getAPK() {
			this.$server
				.getAPPInfo({
					promotionChannel: this.from,
					promotionName: this.filename,
				})
				.then((res) => {
					if (res.code == 200 && res.data && res.data.apk) {
						this.apk = res.data.apk;
					}
				})
				.catch(() => {
					this.apk = this.fallbackApk();
				});
		},
		getOfficalApk(type = 1, domain = null, appname = null) {
			this.$server
				.getOfficalApk({
					domain: domain || 'androidwaves.org',
					appName: appname || 'GB_androidwaves.org',
				})
				.then((res) => {
					if (res.code == 200 && type == 1 && res.data && res.data.apk) {
						this.apk = res.data.apk;
					}
				})
				.catch(() => {
					this.apk = this.fallbackApk();
				});
		},
		download() {
			const apk = this.apk || this.fallbackApk();
			if (apk) {
				this.$global.download(apk);
			}
		},
	},
};
